(function(){
"use strict";
// PDP Creatina Creapure®. Base: lp-bundle.js + los resultados de lp-daily.js (sin modal de etiqueta)
const fmt = n => "$" + n.toLocaleString("es-CL");
// Precios de la Creatina: copiados de Kaching el 16-10 (en la versión final salen de Kaching o de metacampos)
const PACKS = [
  {id:"p1", name:"1 Creatina", perDay:513, price:35900, was:null},
  {id:"p2", name:"2 Creatinas", perDay:357, price:49999, was:71800, tag:"Más vendido"},
  {id:"p3", name:"3 Creatinas", perDay:328, price:68970, was:107700}
];
const pk = id => PACKS.find(x => x.id === id);
const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
const buyEl = () => document.querySelector("kaching-bundle") || document.querySelector(".product-form") || document.querySelector(".product__info-container");
const go = () => { const b = buyEl(); if (b) b.scrollIntoView({behavior: reduce ? "auto" : "smooth", block: "center"}); };
function pickK(id){
  const i = {p1:0, p2:1, p3:2}[id];
  const bars = [...document.querySelectorAll("kaching-bundle .kaching-bundles__bar")].filter(b => !b.classList.contains("kaching-bundles__checkbox-upsells__upsell"));
  if (bars[i]) bars[i].click();
  go();
}
function render(){
  document.querySelectorAll("[data-strip]").forEach(el => {
    el.innerHTML = PACKS.map(p => `<button class="spt" role="radio" aria-checked="false" data-id="${p.id}">
      ${p.tag ? `<span class="tg">${p.tag}</span>` : ""}
      <b>${p.name}</b><span class="pr num">${fmt(p.price)}</span><span class="pd num">${fmt(p.perDay)}/día</span>
      <span class="sh">${p.was ? "Ahorras " + fmt(p.was - p.price) : "Despacho aparte"}</span></button>`).join("");
  });
  const sr = document.getElementById("sRows");
  if (sr) sr.innerHTML = [pk("p2"), pk("p3")].map(r => `<span class="s-row ${r.id==="p2" ? "hi" : ""}"><span class="n">${r.name}</span><b class="num">${fmt(r.perDay)}/día</b><span class="num">${fmt(r.price)}</span></span>`).join("");
}
document.addEventListener("click", e => {
  const sb = e.target.closest(".lp .spt"); if (sb) { pickK(sb.dataset.id); return; }
  const dp = e.target.closest(".lp [data-pick]"); if (dp) { pickK(dp.dataset.pick); return; }
  if (e.target.closest("#sBtn")) go();
});
render();

// Despacho según la hora de Santiago
function despacho(){
  let h = 12;
  try { h = +new Intl.DateTimeFormat("es-CL", {timeZone:"America/Santiago", hour:"numeric", hourCycle:"h23"}).format(new Date()); } catch(e) {}
  const DIAS = ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"];
  let d = new Date();
  try { const p = Object.fromEntries(new Intl.DateTimeFormat("en-US", {timeZone:"America/Santiago", year:"numeric", month:"numeric", day:"numeric"}).formatToParts(d).map(x => [x.type, x.value])); d = new Date(+p.year, +p.month - 1, +p.day); } catch(e) {}
  // Feriados irrenunciables (Ley 19.973): ese día no hay despacho, pasa al día siguiente
  const FER = ["2026-01-01","2026-05-01","2026-09-18","2026-09-19","2026-12-25","2027-01-01","2027-05-01","2027-09-18","2027-09-19","2027-12-25"];
  const ymd = x => x.getFullYear() + "-" + String(x.getMonth() + 1).padStart(2, "0") + "-" + String(x.getDate()).padStart(2, "0");
  let k = h >= 12 ? 1 : 0;
  d.setDate(d.getDate() + k);
  while (FER.includes(ymd(d))) { d.setDate(d.getDate() + 1); k++; }
  const txt = `Llega ${k === 0 ? "hoy" : k === 1 ? "mañana" : "el"} ${DIAS[d.getDay()]} ${d.getDate()} (RM)`;
  document.querySelectorAll("[data-ship]").forEach(el => el.textContent = txt);
}
despacho(); setInterval(despacho, 60000);

// Resultados: el detalle se abre bajo la fila del ícono tocado (patrón de lp-daily.js)
const IC = {
  lift:'<path d="M2.5 12h2M19.5 12h2M6 8v8M18 8v8M4.5 9.5v5M19.5 9.5v5M6 12h12" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linecap="round"/>',
  up:'<path d="M12 3v18M7 8l5-5 5 5" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
  bolt:'<path d="M13 2 5 13h6l-1 9 8-12h-6l1-8z" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linejoin="round"/>',
  focus:'<circle cx="12" cy="12" r="8.5" fill="none" stroke="#1A1B18" stroke-width="2"/><circle cx="12" cy="12" r="4.5" fill="none" stroke="#1A1B18" stroke-width="2"/><circle cx="12" cy="12" r="1.3" fill="#1A1B18"/>'
};
const OUT = [
  {ic:"lift", area:"Fuerza", pain:"En la última serie.", win:"Más fuerza justo cuando más cuesta", body:"Cuando la serie se pone pesada, la creatina ayuda a tu músculo a recuperar energía más rápido: contribuye a aumentar el rendimiento físico en series sucesivas de ejercicio corto de alta intensidad. Si entrenas, se traduce en más repeticiones o más peso. El efecto se obtiene con 3 g diarios; cada scoop trae 5 g.", d:[["Creatina","5 g al día"],["Efecto desde","3 g al día"]], q:["Noto la mejora en fuerza y energía, mayor que las que había usado anteriormente, así que conforme.","Victor A."]},
  {ic:"up", area:"Músculo", pain:"En la fuerza que construyes.", win:"Que tu entrenamiento rinda más", body:"Entrenar fuerza es de lo mejor que puedes hacer por tu cuerpo, a cualquier edad, y la creatina lo potencia. La evidencia es clara en adultos mayores de 55 años que entrenan fuerza: contribuye a potenciar el efecto del entrenamiento sobre la fuerza muscular, con 3 g diarios.", d:[["Creatina","5 g al día"],["Junto a","entrenamiento de fuerza"]]},
  {ic:"bolt", area:"Energía", pain:"En cada esfuerzo intenso.", win:"Más reserva, más rendimiento", body:"Tu cuerpo guarda la creatina como fosfocreatina, la reserva que regenera ATP: la energía inmediata de cada célula. Con las reservas llenas, rindes más antes de cansarte en los esfuerzos cortos e intensos.", d:[["Forma","Monohidrato"],["Pureza","100% Creapure®"]], q:["Llevo meses usándola y realmente me ayuda, ¡me da energías!","Gina E."]},
  {ic:"focus", area:"Cabeza", pain:"En tu cabeza, también.", win:"Energía también para tu cerebro", body:"El cerebro es de los órganos que más energía gasta y también usa creatina como reserva rápida. Por eso hoy la ciencia la estudia mucho más allá del gimnasio.", d:[["Creatina","5 g al día"]]}
];
let oi = 0;
const og = document.getElementById("og");
const wide = matchMedia("(min-width: 720px)");
function renderOut(){
  if (!og) return;
  const tiles = OUT.map((o,i) => `<button class="ot" aria-expanded="${i===oi}" aria-controls="od" data-i="${i}">
      <span class="top"><span class="ic"><svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">${IC[o.ic]}</svg></span><span class="chev" aria-hidden="true">▾</span></span>
      <b>${o.area}</b><span class="p">${o.pain}</span></button>`);
  let html = "";
  const per = wide.matches ? 4 : 2;
  for (let r = 0; r < tiles.length; r += per) {
    html += tiles.slice(r, r + per).join("");
    if (oi >= 0 && Math.floor(oi/per) === r/per) {
      const o = OUT[oi];
      html += `<div class="od" id="od" role="region" aria-label="${o.area}"><p class="label">${o.area}</p><p class="win">${o.win}</p><p>${o.body}</p><div class="doses">${o.d.map(x=>`<span class="dose">${x[0]} <b>${x[1]}</b></span>`).join("")}</div>${o.q ? `<q>"${o.q[0]}"<cite>${o.q[1]} <span class="cv">✓ Compra verificada</span></cite></q>` : ""}</div>`;
    }
  }
  og.innerHTML = html;
}
if (og) og.addEventListener("click", e => {
  const b = e.target.closest(".ot"); if (!b) return;
  const i = +b.dataset.i; oi = (oi === i) ? -1 : i; renderOut();
  og.querySelector(`[data-i="${i}"]`).focus();
});
renderOut();
wide.addEventListener("change", renderOut);

// Barra fija: aparece solo cuando no hay otra compra a la vista (sin ruido de botones)
(function(){
  const bar = document.querySelector(".lp .sticky"); if (!bar) return;
  const zones = () => [document.querySelector(".product__info-container"), document.querySelector(".lp-galeria"), ...document.querySelectorAll(".lp .strip"), document.querySelector(".lp .final")].filter(Boolean);
  const update = () => {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const hide = zones().some(z => { const r = z.getBoundingClientRect(); return r.bottom > 0 && r.top < vh - 40; });
    bar.classList.toggle("is-hidden", hide); bar.toggleAttribute("inert", hide);
  };
  addEventListener("scroll", update, {passive: true}); addEventListener("resize", update);
  update();
})();

// Galería propia: se mueve a la columna de fotos del theme y se arma el carrusel
(function(){
  const g = document.querySelector(".lp-galeria"), mw = document.querySelector(".product__media-wrapper");
  if (g && mw) { mw.prepend(g); document.documentElement.classList.add("lp-gal-ok"); }
  const tr = document.getElementById("track"); if (!tr) return;
  const slides = [...tr.children], n = slides.length;
  const dots = document.getElementById("dots"), th = document.getElementById("thumbs"), cnt = document.getElementById("gcount");
  dots.innerHTML = slides.map((s, i) => `<button class="dot" data-go-slide="${i}" aria-label="Ir a: ${s.dataset.name}"></button>`).join("");
  th.innerHTML = "";
  slides.forEach((s, i) => {
    const b = document.createElement("button"); b.className = "th"; b.dataset.goSlide = i; b.setAttribute("aria-label", "Ir a: " + s.dataset.name);
    const c = s.cloneNode(true); c.setAttribute("aria-hidden", "true"); c.removeAttribute("data-name");
    c.querySelectorAll("button").forEach(x => x.setAttribute("tabindex", "-1"));
    b.appendChild(c); th.appendChild(b);
  });
  const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : tr.clientWidth);
  const idx = () => Math.round(tr.scrollLeft / step());
  const mark = () => { const k = idx(); cnt.textContent = (k + 1) + " / " + n; document.querySelectorAll("[data-go-slide]").forEach(b => b.setAttribute("aria-current", +b.dataset.goSlide === k ? "true" : "false")); };
  const goS = k => { k = (k + n) % n; tr.scrollTo({left: k * step()}); };
  tr.addEventListener("scroll", mark, {passive:true});
  tr.addEventListener("keydown", e => { if (e.key === "ArrowRight") goS(idx() + 1); if (e.key === "ArrowLeft") goS(idx() - 1); });
  document.addEventListener("click", e => {
    const d = e.target.closest("[data-go-slide]"); if (d) { goS(+d.dataset.goSlide); return; }
    const g2 = e.target.closest("[data-gnav]"); if (g2) goS(idx() + +g2.dataset.gnav);
  });
  mark();
})();

})();
